export const GRAPHQL_ENDPOINT =
  process.env.NEXT_PUBLIC_GUARDIAN_GRAPHQL_ENDPOINT ||
  'http://localhost:3006/guardian_graphql'

export const PARTNER_GRAPHQL_ENDPOINT =
  process.env.NEXT_PUBLIC_PARTNER_GRAPHQL_ENDPOINT ||
  'http://localhost:3006/partner_graphql'

export const HOST =
  process.env.NEXT_PUBLIC_GUARDIAN_HOST || 'http://localhost:8000'

export const STRIPE_PUBLISHABLE_KEY =
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || ''

export const ENABLE_BROWSER_ACCESS =
  process.env.NEXT_PUBLIC_ENABLE_BROWSER_ACCESS == 'true' ||
  process.env.NEXT_PUBLIC_ENABLE_BROWSER_ACCESS == '1'

export const GUARDIAN_WEB_ENDPOINT =
  process.env.NEXT_PUBLIC_GUARDIAN_HOST || 'http://localhost:8000'

export const LEANRER_APP_ENDPOINT =
  process.env.NEXT_PUBLIC_LEARNER_APP_ENDPOINT || 'http://localhost:4000'
